import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagementCharterComponent from '../engagement-charter-component'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharterComponent.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharterComponent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Contains the files associated with this record in the shared knowledge base.',
    isOptional: true,
    name: 'Documents',
    partialId: PartialId.Standard.create('documents'),
    type: { isFile: true },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
